import { render, staticRenderFns } from "./ProcessItem.vue?vue&type=template&id=33f6fa9c"
import script from "./ProcessItem.vue?vue&type=script&lang=js"
export * from "./ProcessItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports